package com.cs.ejobin.platform

import kotlinx.browser.window

actual fun replaceUrl(path: String) {
    window.history.replaceState(null, "", path)
}